exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.pagination A {\n  padding-top: 4px;\n}\n.pagination .active A {\n  background: #e2dcd7;\n  color: #fff;\n}\n", ""]);

// exports
